var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorInfoIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#1D7777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editor_info_ic_svg__clip0_1169_1025)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.864 8.47c-.431 0-.786-.139-1.064-.417a1.415 1.415 0 01-.417-1.043c0-.417.139-.765.417-1.043.278-.292.633-.438 1.064-.438.417 0 .765.146 1.043.438.278.278.417.626.417 1.043 0 .418-.14.765-.417 1.043a1.415 1.415 0 01-1.043.417zM14.324 16.559v-5.147a1.47 1.47 0 00-2.941 0v5.147a1.47 1.47 0 102.941 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editor_info_ic_svg__clip0_1169_1025"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 7.353 12.5)",
    d: "M0 0h14.706v14.706H0z"
  })))));
}
export default SvgEditorInfoIc;